import { map } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { clientApiService } from '@cbridge-packages/api';
import { INode, INodeForm } from '../node.interface';

export const updateNodeHandler = async (nodeId: INode['nodeId'], node: INodeForm): Promise<boolean> => {
  const success$ = clientApiService.updateNode({
    nodeId,
    name: node.name,
  }).pipe(
    map(() => {
      return true;
    }),
  );

  return await firstValueFrom(success$);
};
